import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {OrderService} from "../../services/OrderService";
import {Order} from "../../../framework/model/core/order/order";
import {AppDataService} from "../../services/AppDataService";

@Component({
    selector: 'app-due-date-picker',
    templateUrl: './due-date-picker.component.html',
    styleUrls: ['./due-date-picker.component.scss'],
})
export class DueDatePickerComponent implements OnInit {

    public dueDates: Date[];
    public order:Order;
    public due_date;

    constructor(public orderService:OrderService, public appdataService:AppDataService) {
    }

    ngOnInit() {
        this.getOrder();
        this.dueDates = this.appdataService.getPricesListKey('due_dates');
    }

    getOrder()
    {
        this.order = this.orderService.getOrder();
    }

    onDateSelect(): void {
        this.order.data.due_date = new Date(this.due_date);
    }

    getHebrewDayName(dateString) {
        const date = new Date(dateString); // Convert string to Date object
        const dayNames = ['יום א׳', 'יום ב׳', 'יום ג׳', 'יום ד׳', 'יום ה׳', 'יום ו׳', 'שבת'];
        return dayNames[date.getDay()];
    }

}
